export default __webpack_public_path__ + "static/media/BG_Page_02.2f8515be.svg";